import services from './services.js';

export default {
    mixins: [services],
    created () {
        this.visiable = this.value;
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false
        },
        customerId: {
            default: 0
        }
    },
    data () {
        return {
            visiable: false,
            loading: false,
            data: [],
            totalSize: 0,
            pageIndex: 1,
            pageSizes: [10,20,50],
            pageSize: 10,
            C_Name: '',
            currentRow:{},
        };
    },
    computed: {
        sysSid () {
            return this.$store.state.sysSid;
        },
        sysSession () {
            return this.$store.state.sysSession;
        }
    },
    watch: {
        value (val) {
            this.visiable = val;
            this.getContactList(); //获取联系人列表数据
        },
        visiable (val) {
            this.$emit('input', val);
        },
        pageSize () {
            this.getContactList(); //获取联系人列表数据
        },
        pageIndex () {
            this.getContactList(); //获取联系人列表数据
        }
    },
    methods: {
        handleSizeChange (val) {
            this.pageSize = val;
        },
        handleCurrentChange (val) {
            this.pageIndex = val;
        },
        clearField () {
            this.C_Name = '';
        },
        selectRow (row) {
            this.currentRow = row;
        },
        close () {
            this.$emit('input', false);
        },
        confirmSelect () {
            this.$emit('change', this.currentRow);
            this.close();
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/contact-list-dialog/vm.js